import { FunctionComponent } from "react";
import CustomModal from "../CustomModal";
import Text from "../../Text";
import Column from "../../Column";
import { styles } from "../../../styles/themes/style";
import styled from "styled-components";

interface INotFoundUrlsModalProps {
  notFoundIdentifiers: string[];
  onClose: () => void;
}

const NotFoundUrlsModal: FunctionComponent<INotFoundUrlsModalProps> = ({
  notFoundIdentifiers,
  onClose,
}) => {
  // Convert publicIdentifiers to full LinkedIn URLs
  const urls = notFoundIdentifiers.map(
    (identifier) => `https://www.linkedin.com/in/${identifier}/`
  );

  return (
    <CustomModal
      headingText="URLs we couldn't find"
      closeButton
      bodyPadding="0px 24px 24px"
    >
      <Column gap="16px" style={{ width: "100%" }}>
        <Text $paragraph2>
          We suggest adding these profiles to LeadDelta via the LinkedIn Sidebar,
          then come back and add them to the feed again via URL.
        </Text>
        <UrlsList>
          {urls.map((url, index) => (
            <UrlLink
              key={index}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
            >
              {url}
            </UrlLink>
          ))}
        </UrlsList>
      </Column>
    </CustomModal>
  );
};

const UrlsList = styled(Column)`
  gap: 2px;
  max-height: 300px;
  overflow-y: auto;
  padding-right: 4px;

  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: ${styles.colors.black100};
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${styles.colors.black300};
    border-radius: 3px;

    &:hover {
      background: ${styles.colors.black400};
    }
  }
`;

const UrlLink = styled.a`
  color: ${styles.colors.primary600};
  text-decoration: none;
  font-size: 14px;
  line-height: 20px;
  word-break: break-all;
  transition: color 0.2s ease;

  &:hover {
    text-decoration: underline;
    color: ${styles.colors.primary500};
  }

  &:active {
    color: ${styles.colors.primary400};
  }
`;

export default NotFoundUrlsModal;

